(() => {
  if (window.__elportalMobileBottomNavLoaded) return;
  window.__elportalMobileBottomNavLoaded = true;

  const MOBILE_QUERY = '(max-width: 749px), (hover: none) and (pointer: coarse)';
  const DESKTOP_QUERY = '(min-width: 990px) and (hover: hover) and (pointer: fine)';
  const MOBILE_NAV_SELECTOR = '[data-elportal-mobile-bottom-nav]';
  const DESKTOP_NAV_SELECTOR = '[data-elportal-desktop-side-nav]';
  const NAV_SELECTOR = `${MOBILE_NAV_SELECTOR}, ${DESKTOP_NAV_SELECTOR}`;
  const CART_BADGE_SELECTOR = '#cart-icon-bubble .cart-count-bubble, .header__icon--cart .cart-count-bubble, .cart-icon-bubble .cart-count-bubble';
  const HEADER_SEARCH_TRIGGER_SELECTOR = 'details-modal.header__search summary.header__icon--search, details-modal.header__search summary';
  const HEADER_SEARCH_INPUT_SELECTOR = 'details-modal.header__search #Search-In-Modal, details-modal.header__search input[type="search"][name="q"]';
  const PREVIEW_BAR_SELECTOR = '#PBarNextFrameWrapper';
  const DESTINATION_STORAGE_KEY = 'epv_delivery_destination_preview_v1';
  let refreshFrame = 0;
  let lastSearchGestureAt = 0;
  let confirmedCartCount = null;
  let observedHeaderCartCount = null;

  function isSafariBrowser() {
    return /^((?!chrome|android|crios|fxios|edgios).)*safari/i.test(window.navigator.userAgent);
  }

  function cartCountFromBadge() {
    const badge = [...document.querySelectorAll(CART_BADGE_SELECTOR)]
      .find((item) => !item.closest(NAV_SELECTOR));
    if (!badge) return 0;

    const visibleText = badge.querySelector('span[aria-hidden="true"]')?.textContent || badge.textContent || '';
    const match = visibleText.match(/\d+/);
    return match ? Number(match[0]) : 0;
  }

  function updateCartCount(nav, forcedCount = null) {
    const count = Number.isFinite(forcedCount) ? forcedCount : cartCountFromBadge();
    const badge = nav.querySelector('[data-elportal-cart-count], [data-elportal-mobile-cart-count]');
    const cartLink = nav.querySelector('[data-elportal-cart-link], [data-elportal-mobile-cart-link]');
    if (!badge || !cartLink) return;

    if (nav.dataset.elportalCartCount === String(count)) return;
    nav.dataset.elportalCartCount = String(count);

    if (count > 0) {
      const label = `Carrito, ${count} articulos`;
      if (badge.hidden) badge.hidden = false;
      if (badge.textContent !== String(count)) badge.textContent = String(count);
      if (cartLink.getAttribute('aria-label') !== label) cartLink.setAttribute('aria-label', label);
    } else {
      if (!badge.hidden) badge.hidden = true;
      if (badge.textContent) badge.textContent = '';
      if (cartLink.getAttribute('aria-label') !== 'Carrito') cartLink.setAttribute('aria-label', 'Carrito');
    }
  }

  function fixedElementOffset(selector) {
    const element = document.querySelector(selector);
    if (!element) return 0;

    const rect = element.getBoundingClientRect();
    if (!rect.width || !rect.height || rect.bottom <= 0 || rect.top >= window.innerHeight) return 0;

    return Math.ceil(window.innerHeight - rect.top + 12);
  }

  function updateNavOffset(nav) {
    const offset = Math.max(
      14,
      fixedElementOffset(PREVIEW_BAR_SELECTOR)
    );

    if (nav.dataset.elportalBottomOffset === String(offset)) return;

    nav.dataset.elportalBottomOffset = String(offset);
    const value = `${offset}px`;
    nav.style.setProperty('--elportal-mobile-bottom-nav-offset', value);
    document.body.style.setProperty('--elportal-mobile-bottom-nav-offset', value);
  }

  function readDestinationSelection() {
    try {
      const selection = JSON.parse(localStorage.getItem(DESTINATION_STORAGE_KEY));
      return selection && typeof selection === 'object' ? selection : null;
    } catch (error) {
      return null;
    }
  }

  function destinationNavState(selection) {
    if (!selection?.country) {
      return {
        title: 'Destino',
        subtitle: 'Elegir',
        ariaLabel: 'Elegir destino de entrega'
      };
    }

    if (selection.country === 'Colombia') {
      if (!selection.city) {
        return {
          title: 'Colombia',
          subtitle: 'Elegir ciudad',
          ariaLabel: 'Elegir ciudad de entrega en Colombia'
        };
      }

      const locality = selection.locality ? `, localidad ${selection.locality}` : '';
      return {
        title: selection.city,
        subtitle: 'Cambiar',
        ariaLabel: `Cambiar ciudad de entrega, actualmente ${selection.city}${locality}`
      };
    }

    return {
      title: selection.country === 'Estados Unidos' ? 'EE. UU.' : selection.country,
      subtitle: 'Cambiar país',
      ariaLabel: `Cambiar país de entrega, actualmente ${selection.country}`
    };
  }

  function updateDestinationNavs(selection = readDestinationSelection()) {
    const state = destinationNavState(selection);
    document.querySelectorAll('[data-epv-open-destination]').forEach((trigger) => {
      if (trigger.closest('epv-delivery-selector')) return;
      trigger.setAttribute('aria-label', state.ariaLabel);
      trigger.setAttribute('title', state.ariaLabel);
      const title = trigger.querySelector('[data-epv-destination-nav-title]');
      const subtitle = trigger.querySelector('[data-epv-destination-nav-subtitle]');
      if (title) title.textContent = state.title;
      if (subtitle) subtitle.textContent = state.subtitle;
    });
  }

  function refreshNavs(forcedCount = null) {
    const headerCount = cartCountFromBadge();
    if (Number.isFinite(forcedCount)) {
      confirmedCartCount = forcedCount;
    } else if (observedHeaderCartCount === null) {
      observedHeaderCartCount = headerCount;
      confirmedCartCount = headerCount;
    } else if (headerCount !== observedHeaderCartCount) {
      observedHeaderCartCount = headerCount;
      confirmedCartCount = headerCount;
    }

    const count = Number.isFinite(confirmedCartCount) ? confirmedCartCount : headerCount;
    document.querySelectorAll(NAV_SELECTOR).forEach((nav) => updateCartCount(nav, count));

    const mobileNav = document.querySelector(MOBILE_NAV_SELECTOR);
    if (mobileNav) updateNavOffset(mobileNav);
  }

  function scheduleRefresh() {
    if (refreshFrame) return;

    refreshFrame = window.requestAnimationFrame(() => {
      refreshFrame = 0;
      refreshNavs();
    });
  }

  function mutationIsInsideNav(mutation) {
    const target = mutation.target;
    return target instanceof Element
      ? Boolean(target.closest(NAV_SELECTOR))
      : Boolean(target.parentElement?.closest(NAV_SELECTOR));
  }

  function focusThemeSearchInput(selectText = false, immediate = false) {
    const input = document.querySelector(HEADER_SEARCH_INPUT_SELECTOR);
    if (!input) return;

    const applyFocus = () => {
      input.focus({ preventScroll: true });
      if (selectText && typeof input.select === 'function') input.select();
    };

    if (immediate) {
      applyFocus();
      return;
    }

    window.requestAnimationFrame(applyFocus);
  }

  function isSearchTriggerVisible(summary) {
    const rect = summary.getBoundingClientRect();
    return rect.width > 0
      && rect.height > 0
      && rect.top >= 0
      && rect.bottom <= window.innerHeight;
  }

  function openHeaderSearch(summary, details, selectText, immediateFocus = false) {
    if (!details?.open) summary.click();
    focusThemeSearchInput(selectText, immediateFocus);
    window.setTimeout(() => focusThemeSearchInput(selectText), 180);
  }

  function closeCategoryModalBeforeSearch() {
    document.dispatchEvent(new CustomEvent('elportal:close-category-modal'));
    document
      .querySelectorAll('[data-elportal-category-modal]:not([hidden]) [data-elportal-category-close]')
      .forEach((button) => button.click());
  }

  function openThemeSearch(event) {
    const summary = document.querySelector(HEADER_SEARCH_TRIGGER_SELECTOR);
    if (!summary) return false;

    event.preventDefault();
    event.stopPropagation();

    closeCategoryModalBeforeSearch();
    const details = summary.closest('details');
    // iOS only opens the virtual keyboard when focus happens inside the
    // original trusted tap. Delaying this first focus made the search open
    // visually without presenting the keyboard on a real phone.
    openHeaderSearch(summary, details, true, true);
    return true;
  }

  function handleSearchGesture(event) {
    if (event.type === 'pointerup' && event.pointerType === 'mouse') return;

    const searchTrigger = event.target.closest('[data-elportal-open-search]');
    if (!searchTrigger || !searchTrigger.closest(NAV_SELECTOR)) return;

    const now = window.performance?.now?.() || Date.now();
    if (event.type === 'click' && now - lastSearchGestureAt < 700) {
      event.preventDefault();
      event.stopPropagation();
      return;
    }

    lastSearchGestureAt = now;
    openThemeSearch(event);
  }

  function injectStyles() {
    if (document.getElementById('elportal-mobile-bottom-nav-styles')) return;
    const style = document.createElement('style');
    style.id = 'elportal-mobile-bottom-nav-styles';
    style.textContent = `
      .elportal-mobile-bottom-nav {
        position: fixed;
        left: 50%;
        bottom: calc(var(--elportal-mobile-bottom-nav-offset, 14px) + env(safe-area-inset-bottom));
        z-index: 2147482800;
        width: min(390px, calc(100vw - 28px));
        min-height: 70px;
        display: none;
        align-items: center;
        justify-content: space-between;
        gap: 2px;
        padding: 8px;
        border: 2px solid rgba(238, 168, 74, 0.9);
        border-radius: 28px;
        background: #fffaf2;
        box-shadow: 0 14px 36px rgba(122, 45, 16, 0.18);
        transform: translateX(-50%);
        font-family: inherit;
      }

      .elportal-mobile-bottom-nav__link {
        position: relative;
        display: inline-flex;
        min-width: 0;
        flex: 1 1 0;
        align-items: center;
        justify-content: center;
        gap: 4px;
        flex-direction: column;
        min-height: 54px;
        margin: 0;
        padding: 0;
        border-radius: 18px;
        box-sizing: border-box;
        color: #8b160f;
        background: transparent;
        border: 0;
        text-decoration: none;
        font-family: inherit;
        font-size: 9px;
        font-weight: 800;
        line-height: 1;
        -webkit-tap-highlight-color: transparent;
      }

      .elportal-mobile-bottom-nav__icon {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        width: 28px;
        height: 28px;
        color: #a25b10;
      }

      .elportal-mobile-bottom-nav__icon svg {
        width: 24px;
        height: 24px;
        stroke: currentColor;
        stroke-width: 2;
        fill: none;
        stroke-linecap: round;
        stroke-linejoin: round;
      }

      .elportal-mobile-bottom-nav__icon--emoji {
        font-size: 24px;
        line-height: 1;
      }

      .elportal-mobile-bottom-nav__cart {
        flex: 0 0 78px;
        min-height: 64px;
        margin-top: -22px;
        border: 2px solid #eea84a;
        border-radius: 22px;
        background: #8b160f;
        color: #fffaf2;
        box-shadow: 0 12px 24px rgba(139, 22, 15, 0.28);
      }

      .elportal-mobile-bottom-nav__cart .elportal-mobile-bottom-nav__icon {
        width: 34px;
        height: 32px;
        color: #fffaf2;
      }

      .elportal-mobile-bottom-nav__cart .elportal-mobile-bottom-nav__icon svg {
        width: 28px;
        height: 28px;
      }

      .elportal-mobile-bottom-nav__whatsapp .elportal-mobile-bottom-nav__icon {
        width: 32px;
        height: 32px;
      }

      .elportal-mobile-bottom-nav__whatsapp .elportal-mobile-bottom-nav__icon svg {
        width: 30px;
        height: 30px;
        fill: none;
        stroke: none;
        filter: drop-shadow(0 4px 5px rgba(14, 79, 39, 0.3));
      }

      .elportal-mobile-bottom-nav__whatsapp-fill {
        fill: #25d366;
      }

      .elportal-mobile-bottom-nav__whatsapp-mark {
        fill: #ffffff;
      }

      .elportal-mobile-bottom-nav__label {
        display: block;
        max-width: 100%;
        padding-bottom: 1px;
        overflow: hidden;
        text-overflow: ellipsis;
        line-height: 1.2;
        white-space: nowrap;
      }

      .elportal-mobile-bottom-nav__count {
        position: absolute;
        top: 2px;
        right: 18px;
        min-width: 20px;
        height: 20px;
        padding: 0 6px;
        border: 2px solid #fffaf2;
        border-radius: 999px;
        background: #eea84a;
        color: #8b160f;
        font-size: 11px;
        font-weight: 900;
        line-height: 16px;
        text-align: center;
      }

      .elportal-mobile-bottom-nav__count[hidden] {
        display: none;
      }

      .elportal-desktop-side-nav {
        position: fixed;
        left: 0;
        top: 50%;
        z-index: 2147482400;
        display: none;
        width: 80px;
        padding: 16px 8px 16px 6px;
        border: 2px solid rgba(238, 168, 74, 0.9);
        border-left: 0;
        border-radius: 0 30px 30px 0;
        background: #fffaf2;
        box-shadow: 0 16px 36px rgba(122, 45, 16, 0.18);
        transform: translateY(-50%);
        transform-origin: left center;
        font-family: inherit;
      }

      .elportal-desktop-side-nav[data-elportal-safari="true"] {
        transform: translateY(-50%) scale(0.86);
      }

      .elportal-desktop-side-nav__inner {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        gap: 12px;
        width: 100%;
      }

      .elportal-desktop-side-nav__link {
        position: relative;
        display: inline-flex;
        width: 56px;
        min-height: 56px;
        align-items: center;
        justify-content: center;
        gap: 4px;
        flex-direction: column;
        border-radius: 18px;
        color: #8b160f;
        background: transparent;
        border: 0;
        text-decoration: none;
        font-family: inherit;
        font-size: 9px;
        font-weight: 800;
        line-height: 1.1;
        letter-spacing: 0;
        transition: transform 140ms ease, color 140ms ease, background-color 140ms ease;
      }

      .elportal-desktop-side-nav__link:hover,
      .elportal-desktop-side-nav__link:focus-visible {
        color: #9b4f05;
        background: rgba(238, 168, 74, 0.12);
        transform: translateY(-1px);
      }

      :root[data-epv-destination-confirmed] .elportal-mobile-bottom-nav [data-epv-open-destination],
      :root[data-epv-destination-confirmed] .elportal-desktop-side-nav [data-epv-open-destination] {
        color: #9b4f05;
        background: rgba(238, 168, 74, 0.12);
      }

      .elportal-desktop-side-nav__icon {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        width: 26px;
        height: 26px;
        color: currentColor;
      }

      .elportal-desktop-side-nav__icon svg {
        width: 24px;
        height: 24px;
        stroke: currentColor;
        stroke-width: 2;
        fill: none;
        stroke-linecap: round;
        stroke-linejoin: round;
      }

      .elportal-desktop-side-nav__cart {
        width: 60px;
        min-height: 60px;
        border: 2px solid #eea84a;
        border-radius: 18px;
        background: #8b160f;
        color: #fffaf2;
        box-shadow: 0 12px 24px rgba(139, 22, 15, 0.28);
      }

      .elportal-desktop-side-nav__label {
        display: block;
        max-width: 100%;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }

      .elportal-desktop-side-nav__destination {
        gap: 2px;
      }

      .elportal-desktop-side-nav__destination-subtitle {
        display: block;
        max-width: 100%;
        overflow: hidden;
        color: currentColor;
        font-size: 8px;
        font-weight: 700;
        line-height: 1;
        opacity: 0.76;
        text-overflow: ellipsis;
        white-space: nowrap;
      }

      .elportal-desktop-side-nav__count {
        position: absolute;
        top: -6px;
        right: -6px;
        min-width: 22px;
        height: 22px;
        padding: 0 6px;
        border: 2px solid #fffaf2;
        border-radius: 999px;
        background: #eea84a;
        color: #8b160f;
        font-size: 11px;
        font-weight: 900;
        line-height: 18px;
        text-align: center;
      }

      .elportal-desktop-side-nav__count[hidden] {
        display: none;
      }

      .elportal-desktop-side-nav__whatsapp .elportal-desktop-side-nav__icon {
        width: 29px;
        height: 29px;
      }

      .elportal-desktop-side-nav__whatsapp .elportal-desktop-side-nav__icon svg {
        width: 28px;
        height: 28px;
        fill: none;
        stroke: none;
        filter: drop-shadow(0 4px 5px rgba(14, 79, 39, 0.3));
      }

      @media screen and (max-width: 749px), (hover: none) and (pointer: coarse) {
        .elportal-mobile-bottom-nav {
          display: flex;
        }

        [data-elportal-whatsapp-button] {
          display: none !important;
        }

        body.elportal-mobile-bottom-nav-ready {
          padding-bottom: calc(84px + var(--elportal-mobile-bottom-nav-offset, 14px) + env(safe-area-inset-bottom));
        }
      }

      @media screen and (min-width: 990px) and (hover: hover) and (pointer: fine) {
        .elportal-desktop-side-nav {
          display: block;
        }

        [data-elportal-whatsapp-button] {
          display: none !important;
        }
      }

      @media screen and (max-width: 360px) {
        .elportal-mobile-bottom-nav {
          width: min(360px, calc(100vw - 18px));
          padding-inline: 10px;
          gap: 3px;
        }

        .elportal-mobile-bottom-nav__link {
          min-width: 0;
          font-size: 8px;
        }

        .elportal-mobile-bottom-nav__cart {
          flex-basis: 72px;
        }
      }
    `;
    document.head.appendChild(style);
  }

  function buildMobileNav() {
    const nav = document.createElement('nav');
    const whatsappSource = document.querySelector('[data-elportal-whatsapp-button]');
    const whatsappHref = whatsappSource?.href || 'https://wa.me/573227536670?text=Hola%2C+quiero+comprar....';
    nav.className = 'elportal-mobile-bottom-nav';
    nav.dataset.elportalMobileBottomNav = 'true';
    nav.setAttribute('aria-label', 'Navegacion principal movil');
    nav.innerHTML = `
      <a class="elportal-mobile-bottom-nav__link" href="/search" data-elportal-open-search aria-label="Búsqueda">
        <span class="elportal-mobile-bottom-nav__icon" aria-hidden="true">
          <svg viewBox="0 0 24 24"><circle cx="11" cy="11" r="7"></circle><path d="m16.5 16.5 4 4"></path></svg>
        </span>
        <span class="elportal-mobile-bottom-nav__label">Búsqueda</span>
      </a>
      <a class="elportal-mobile-bottom-nav__link" href="/collections" aria-label="Categorías">
        <span class="elportal-mobile-bottom-nav__icon elportal-mobile-bottom-nav__icon--emoji" aria-hidden="true">
          🗂️
        </span>
        <span class="elportal-mobile-bottom-nav__label">Categorías</span>
      </a>
      <a class="elportal-mobile-bottom-nav__link elportal-mobile-bottom-nav__cart" href="/cart" data-elportal-cart-link data-elportal-mobile-cart-link aria-label="Carrito">
        <span class="elportal-mobile-bottom-nav__icon" aria-hidden="true">
          <svg viewBox="0 0 24 24"><path d="M6 7h14l-1.4 8.4a2 2 0 0 1-2 1.6H9.1a2 2 0 0 1-2-1.6L5 3H2"></path><circle cx="9" cy="21" r="1"></circle><circle cx="17" cy="21" r="1"></circle></svg>
        </span>
        <span class="elportal-mobile-bottom-nav__label">Carrito</span>
        <span class="elportal-mobile-bottom-nav__count" data-elportal-cart-count data-elportal-mobile-cart-count hidden></span>
      </a>
      <button class="elportal-mobile-bottom-nav__link" type="button" data-epv-open-destination aria-label="Elegir destino de entrega">
        <span class="elportal-mobile-bottom-nav__icon" aria-hidden="true">
          <svg viewBox="0 0 24 24"><path d="M20 10c0 5-8 11-8 11S4 15 4 10a8 8 0 1 1 16 0Z"></path><circle cx="12" cy="10" r="2.5"></circle></svg>
        </span>
        <span class="elportal-mobile-bottom-nav__label" data-epv-destination-nav-title>Destino</span>
      </button>
      <a class="elportal-mobile-bottom-nav__link elportal-mobile-bottom-nav__whatsapp" href="#" data-elportal-mobile-whatsapp aria-label="WhatsApp" title="WhatsApp">
        <span class="elportal-mobile-bottom-nav__icon" aria-hidden="true">
          <svg viewBox="0 0 24 24" focusable="false">
            <path class="elportal-mobile-bottom-nav__whatsapp-fill" d="M12.055 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 0 0 5.688 1.448h.005c6.558 0 11.894-5.335 11.897-11.893A11.821 11.821 0 0 0 20.462 3.488 11.815 11.815 0 0 0 12.055 0Z"></path>
            <path class="elportal-mobile-bottom-nav__whatsapp-mark" d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479s1.065 2.875 1.213 3.074c.149.198 2.095 3.2 5.076 4.487.709.306 1.262.489 1.694.626.712.227 1.36.195 1.872.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.29.173-1.414-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 0 1-5.031-1.378l-.361-.214-3.741.981.998-3.648-.235-.374a9.86 9.86 0 0 1-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 0 1 2.893 6.994c-.003 5.45-4.437 9.884-9.889 9.884m8.413-18.297A11.815 11.815 0 0 0 12.055 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 0 0 5.688 1.448h.005c6.558 0 11.894-5.335 11.897-11.893a11.821 11.821 0 0 0-3.49-8.413Z"></path>
          </svg>
        </span>
        <span class="elportal-mobile-bottom-nav__label">WhatsApp</span>
      </a>
    `;
    const mobileWhatsApp = nav.querySelector('[data-elportal-mobile-whatsapp]');
    if (mobileWhatsApp) {
      mobileWhatsApp.href = whatsappHref;
      mobileWhatsApp.target = whatsappSource?.target || '_blank';
      mobileWhatsApp.rel = whatsappSource?.rel || 'noopener noreferrer';
    }
    return nav;
  }

  function buildDesktopNav() {
    const nav = document.createElement('nav');
    const whatsappSource = document.querySelector('[data-elportal-whatsapp-button]');
    const whatsappHref = whatsappSource?.href || 'https://wa.me/573227536670?text=Hola%2C+quiero+comprar....';
    nav.className = 'elportal-desktop-side-nav';
    nav.dataset.elportalDesktopSideNav = 'true';
    if (isSafariBrowser()) nav.dataset.elportalSafari = 'true';
    nav.setAttribute('aria-label', 'Navegacion principal escritorio');
    nav.innerHTML = `
      <div class="elportal-desktop-side-nav__inner">
        <a class="elportal-desktop-side-nav__link" href="/search" data-elportal-open-search aria-label="Buscar productos" title="Búsqueda">
          <span class="elportal-desktop-side-nav__icon" aria-hidden="true">
            <svg viewBox="0 0 24 24"><circle cx="11" cy="11" r="7"></circle><path d="m16.5 16.5 4 4"></path></svg>
          </span>
          <span class="elportal-desktop-side-nav__label">Buscar</span>
        </a>
        <a class="elportal-desktop-side-nav__link" href="/collections" aria-label="Ver categorias" title="Categorías">
          <span class="elportal-desktop-side-nav__icon" aria-hidden="true">
            <svg viewBox="0 0 24 24"><path d="M4 7h16"></path><path d="M4 12h16"></path><path d="M4 17h16"></path></svg>
          </span>
          <span class="elportal-desktop-side-nav__label">Categorías</span>
        </a>
        <a class="elportal-desktop-side-nav__link elportal-desktop-side-nav__cart" href="/cart" data-elportal-cart-link aria-label="Carrito" title="Carrito">
          <span class="elportal-desktop-side-nav__icon" aria-hidden="true">
            <svg viewBox="0 0 24 24"><path d="M6 7h14l-1.4 8.4a2 2 0 0 1-2 1.6H9.1a2 2 0 0 1-2-1.6L5 3H2"></path><circle cx="9" cy="21" r="1"></circle><circle cx="17" cy="21" r="1"></circle></svg>
          </span>
          <span class="elportal-desktop-side-nav__label">Carrito</span>
          <span class="elportal-desktop-side-nav__count" data-elportal-cart-count hidden></span>
        </a>
        <button class="elportal-desktop-side-nav__link elportal-desktop-side-nav__destination" type="button" data-epv-open-destination aria-label="Elegir destino de entrega" title="Destino">
          <span class="elportal-desktop-side-nav__icon" aria-hidden="true">
            <svg viewBox="0 0 24 24"><path d="M20 10c0 5-8 11-8 11S4 15 4 10a8 8 0 1 1 16 0Z"></path><circle cx="12" cy="10" r="2.5"></circle></svg>
          </span>
          <span class="elportal-desktop-side-nav__label" data-epv-destination-nav-title>Destino</span>
          <span class="elportal-desktop-side-nav__destination-subtitle" data-epv-destination-nav-subtitle>Elegir</span>
        </button>
        <a class="elportal-desktop-side-nav__link elportal-desktop-side-nav__whatsapp" href="#" data-elportal-desktop-whatsapp aria-label="WhatsApp" title="WhatsApp">
          <span class="elportal-desktop-side-nav__icon" aria-hidden="true">
            <svg viewBox="0 0 24 24" focusable="false">
              <path class="elportal-mobile-bottom-nav__whatsapp-fill" d="M12.055 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 0 0 5.688 1.448h.005c6.558 0 11.894-5.335 11.897-11.893A11.821 11.821 0 0 0 20.462 3.488 11.815 11.815 0 0 0 12.055 0Z"></path>
              <path class="elportal-mobile-bottom-nav__whatsapp-mark" d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479s1.065 2.875 1.213 3.074c.149.198 2.095 3.2 5.076 4.487.709.306 1.262.489 1.694.626.712.227 1.36.195 1.872.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.29.173-1.414-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 0 1-5.031-1.378l-.361-.214-3.741.981.998-3.648-.235-.374a9.86 9.86 0 0 1-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 0 1 2.893 6.994c-.003 5.45-4.437 9.884-9.889 9.884m8.413-18.297A11.815 11.815 0 0 0 12.055 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 0 0 5.688 1.448h.005c6.558 0 11.894-5.335 11.897-11.893a11.821 11.821 0 0 0-3.49-8.413Z"></path>
            </svg>
          </span>
          <span class="elportal-desktop-side-nav__label">WhatsApp</span>
        </a>
      </div>
    `;
    const desktopWhatsApp = nav.querySelector('[data-elportal-desktop-whatsapp]');
    if (desktopWhatsApp) {
      desktopWhatsApp.href = whatsappHref;
      desktopWhatsApp.target = whatsappSource?.target || '_blank';
      desktopWhatsApp.rel = whatsappSource?.rel || 'noopener noreferrer';
    }
    return nav;
  }

  function init() {
    injectStyles();

    observedHeaderCartCount = cartCountFromBadge();
    confirmedCartCount = observedHeaderCartCount;

    if (!document.querySelector(MOBILE_NAV_SELECTOR)) {
      const mobileNav = buildMobileNav();
      document.body.classList.add('elportal-mobile-bottom-nav-ready');
      document.body.appendChild(mobileNav);
    }

    if (!document.querySelector(DESKTOP_NAV_SELECTOR)) {
      document.body.appendChild(buildDesktopNav());
    }

    updateDestinationNavs();
    refreshNavs();

    const observer = new MutationObserver((mutations) => {
      if (mutations.length && mutations.every(mutationIsInsideNav)) return;
      scheduleRefresh();
    });
    observer.observe(document.body, { childList: true, subtree: true, characterData: true });

    window.addEventListener('pageshow', () => {
      scheduleRefresh();
    });
    window.addEventListener('focus', () => {
      scheduleRefresh();
    });
    window.addEventListener('resize', scheduleRefresh);
    window.addEventListener('orientationchange', scheduleRefresh);
    document.addEventListener('elportal:cart-count-updated', (event) => {
      const count = Number(event.detail?.count || 0);
      if (Number.isFinite(count)) refreshNavs(count);
    });
    document.addEventListener('epv:destination-changed', (event) => {
      updateDestinationNavs(event.detail?.selection || null);
    });
    document.addEventListener('touchend', handleSearchGesture, { capture: true, passive: false });
    document.addEventListener('pointerup', handleSearchGesture, true);
    document.addEventListener('click', handleSearchGesture);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
